export default __webpack_public_path__ + "static/media/kafka-svgrepo-com.06dc3ec3.svg";